import { render, staticRenderFns } from "./NewsTagsTable.vue?vue&type=template&id=57bc6d85&scoped=true&"
import script from "./NewsTagsTable.vue?vue&type=script&lang=js&"
export * from "./NewsTagsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bc6d85",
  null
  
)

export default component.exports